import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-other-info",
  templateUrl: "./dental-other-info.component.html",
  styleUrls: ["./dental-other-info.component.scss"],
})
export class DentalOtherInfoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
